export default class StartMessageNotificationDetailCtrl{
  constructor($scope, $state,$stateParams, GeneralSettingsSrv){

    var startMessageNotificationVm = this
    startMessageNotificationVm.showInputDates = false

    activate()

    function activate() {

      if( !$stateParams.notificationId ) 
        $state.go('generalSettings.notificationsManagement');

      return getScheduleNotificationType().then(
        getNotification($stateParams.notificationId).then( () => {} )
      );
    }

    function getScheduleNotificationType() {
      
      return GeneralSettingsSrv.scheduleNotificationType.getList()
      .$promise.then(function(dataReturn) {
        if(dataReturn.status == true)
          startMessageNotificationVm.schedules = dataReturn.data
        else
         console.log(dataReturn)
      },function(data) {
       console.log(data)
      });
    }

    function getNotification( notificationId ) {
      return GeneralSettingsSrv.getNotificationById.get({notificationId: notificationId})
      .$promise.then(function(dataReturn) {
        if( dataReturn.status == true ){
          if( dataReturn.data )
            startMessageNotificationVm.message = formatNotification( dataReturn.data[0] )
        }
        else{}
          
        },function(data) {
          console.log(data)
      })
    }

    function formatNotification (notification) {
      if(notification.asunto)
        notification.dsName = notification.asunto
      if(notification.ds_description)
        notification.dsDescription = notification.ds_description
      if(notification.id_schedule_notification_type)
        notification.scheduleNotificationTypeId = notification.id_schedule_notification_type
      if(notification.start_date && moment(notification.start_date).isValid() 
        && notification.end_date && moment(notification.end_date).isValid()){
        notification.startDate = moment(notification.start_date , 'YYYY-MM-DD').toDate()
        notification.endDate = moment(notification.end_date , 'YYYY-MM-DD').toDate()
        startMessageNotificationVm.showInputDates = true
      }
      return notification
    }

  }//FIN DEL CONSTRUCTOR

    preventInput(event){
      var  vKey = 86
      if (event.keyCode == vKey)
        event.preventDefault()
      return;     
    }
}

StartMessageNotificationDetailCtrl.$inject = ['$scope', '$state','$stateParams','GeneralSettingsSrv']


// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/startMessage/startMessageNotificationDetailCtrl.js